export default __webpack_public_path__ + "static/media/fabricated_banner.1e6a7e32.png";